import { Box } from '@chakra-ui/react';

type PasswordRulesChecklistProperties = {
  password: string;
  submitCount: number;
};

export const getPasswordRules = (password: string) => [
  { label: 'Minimum 8 characters', isMet: password.length >= 8 },
  { label: 'At least 1 number', isMet: /\d/.test(password) },
  { label: 'At least 1 uppercase letter', isMet: /[A-Z]/.test(password) },
  { label: 'At least 1 lowercase letter', isMet: /[a-z]/.test(password) },
  {
    label: 'At least 1 symbol',
    isMet: /[^\dA-Za-z]/.test(password),
  },
];

const PasswordRulesChecklist = ({ password, submitCount }: PasswordRulesChecklistProperties) => {
  const passwordRules = getPasswordRules(password);
  const showUnmetPasswordRulesInRed = submitCount > 0;

  return (
    <Box mt='0'>
      {passwordRules.map((rule) => {
        const ruleColor = rule.isMet
          ? '#2E7D32'
          : showUnmetPasswordRulesInRed
          ? '#D32F2F'
          : '#82736C';
        return (
          <Box
            as='p'
            key={rule.label}
            fontSize='12px'
            fontWeight='500'
            sx={{ color: ruleColor }}
            m={0}
          >
            {rule.isMet ? '✓' : '○'} {rule.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordRulesChecklist;
